import { render, staticRenderFns } from "./SelectArea.vue?vue&type=template&id=2eb700c0&"
import script from "./SelectArea.vue?vue&type=script&lang=ts&"
export * from "./SelectArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports